import React from 'react';
import { Leaf, Package, Wind, CheckCircle } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function Products() {
  const {
    t
  } = useLanguage();
  const products = [{
    icon: Leaf,
    name: t.products.items.driedLeaves.name,
    description: t.products.items.driedLeaves.description,
    features: t.products.items.driedLeaves.features
  }, {
    icon: Package,
    name: t.products.items.powder.name,
    description: t.products.items.powder.description,
    features: t.products.items.powder.features
  }, {
    icon: Wind,
    name: t.products.items.crushedLeaf.name,
    description: t.products.items.crushedLeaf.description,
    features: t.products.items.crushedLeaf.features
  }];
  return <section id="products" className="w-full py-16 md:py-24 bg-white" data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-203">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-204">
            {t.products.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-205">
            {t.products.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-206">
            {t.products.subtitle}
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-16" data-id="element-207">
          {products.map((product, index) => <div key={index} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100 group" data-id="element-208">
              <div className="w-16 h-16 bg-emerald-100 group-hover:bg-emerald-700 rounded-2xl flex items-center justify-center mb-6 transition-colors duration-300" data-id="element-209">
                <product.icon className="w-8 h-8 text-emerald-700 group-hover:text-white transition-colors duration-300" data-id="element-210" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-211">
                {product.name}
              </h3>
              <p className="text-gray-600 mb-5 leading-relaxed" data-id="element-212">
                {product.description}
              </p>
              <ul className="space-y-2" data-id="element-213">
                {product.features.map((feature, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-gray-600" data-id="element-214">
                    <CheckCircle className="w-4 h-4 text-emerald-600" data-id="element-215" />
                    {feature}
                  </li>)}
              </ul>
            </div>)}
        </div>

        {/* Processing Section */}
        <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-3xl p-8 md:p-12" data-id="element-216">
          <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-217">
            <div data-id="element-218">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-219">
                {t.products.processing.title}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-220">
                {t.products.processing.description}
              </p>
              <ul className="space-y-4" data-id="element-221">
                {t.products.processing.steps.map((step, index) => <li key={index} className="flex items-start gap-4" data-id="element-222">
                    <div className="w-8 h-8 bg-emerald-700 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-sm" data-id="element-223">
                      {index + 1}
                    </div>
                    <span className="text-gray-700 pt-1" data-id="element-224">{step}</span>
                  </li>)}
              </ul>
            </div>
            <div className="flex justify-center" data-id="element-225">
              <div className="bg-white rounded-2xl p-8 shadow-lg" data-id="element-226">
                <img src="https://cdn.magicpatterns.com/uploads/t37N25GpwJa9GYRmF4gvMx/1.png" alt="KBIN Quality Processing" className="w-48 h-auto mx-auto" data-id="element-227" />
                <p className="text-center text-emerald-700 font-semibold mt-4" data-id="element-228">
                  {t.products.processing.badge}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}